import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'timeAgo' })
export class TimeAgoPipe implements PipeTransform {
  private static YEAR_MS: number = 1000 * 60 * 60 * 24 * 7 * 4 * 12;
  private static MAPPER: any = [
    { single: '1 năm trước', many: 'năm', div: 1 },
    { single: 'tháng trước', many: 'tháng', div: 12 },
    { single: 'tuần trước', many: 'tuần', div: 4 },
    { single: 'hôm qua', many: 'ngày', div: 7 },
    { single: 'giờ trước', many: 'giờ', div: 24 },
    { single: 'hiện tại', many: 'phút', div: 60 },
  ];

  /**
   * @param inputDate: Date | Moment - not included as TypeScript interface,
   * in order to keep `ngx-pipes` "pure" from dependencies!
   */
  public transform(inputDate: any): string {
    inputDate = new Date(inputDate)
    if (!inputDate || (!inputDate.getTime && !inputDate.toDate)) {
      return 'Invalid date';
    }

    const past = inputDate.toDate ? inputDate.toDate() : inputDate.getTime();
    const now = +new Date();

    if (past > now) {
      return 'trong tương lai';
    }

    for (let i = 0, l = TimeAgoPipe.MAPPER.length, ms = now - past, div = TimeAgoPipe.YEAR_MS; i < l; ++i) {
      const elm = TimeAgoPipe.MAPPER[i];
      const unit = Math.floor(ms / (div /= elm.div));

      if (unit >= 1) {
        return unit === 1 ? elm.single : `${unit} ${elm.many}`;
      }
    }

    return 'hiện tại';
  }
}
